import React from 'react';
import SvgIcon from './SvgIcon';

const EditFull = props => {
    return (
        <SvgIcon viewBox="0 0 17 16" {...props}>
            <g id="1️⃣-Massive-Natural-Event" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="13.2---Map---Edit-Indicator"
                    transform="translate(-1206.000000, -484.000000)"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                >
                    <g id="map-tools" transform="translate(60.000000, 76.000000)">
                        <g id="Group" transform="translate(1117.000000, 148.000000)">
                            <g id="EDIT" transform="translate(26.500000, 260.000000)">
                                <g id="i-edit" transform="translate(3.000000, 0.000000)">
                                    <path
                                        d="M16,14 L16,16 L0,16 L0,14 L16,14 Z M8.7,0.3 C9.1,-0.1 9.7,-0.1 10.1,0.3 L10.1,0.3 L11.7,1.9 C12.1,2.3 12.1,2.9 11.7,3.3 L11.7,3.3 L3,12 L0,12 L0,9 Z"
                                        id="Combined-Shape-Copy"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

EditFull.displayName = 'EditFullIcon';

export default EditFull;
